import fetchOne from './fetchOne'

const InvoiceAutomationAction = {
  fetchOne
}

export default InvoiceAutomationAction
